export class Feature {
  name: string;
  code: string;
  constructor(data: any) {
    this.name = data.name || '';
    this.code = data.code || '';
  }
}
